import { useAuth } from '../../auth/useAuth';
import { StatusChip } from '../../design-system/components/StatusChip';
import { AlertBanner } from '../../design-system/components/AlertBanner';
import { getRuntimeConfig } from '../../config/runtime-config';
import './AccessScreen.css';

export function AccessScreen() {
  const { user } = useAuth();
  const cfg = getRuntimeConfig();

  if (!user) return null;

  return (
    <div className="nx-access">
      <h1 className="nx-section-title">Access</h1>
      <AlertBanner variant="info" title="Read-only access view">
        Phase 1 does not support user lifecycle management.
      </AlertBanner>

      <section className="nx-access__card">
        <div className="nx-access__row">
          <span className="nx-access__label">Display Name</span>
          <span className="nx-access__value">{user.displayName}</span>
        </div>
        <div className="nx-access__row">
          <span className="nx-access__label">Email</span>
          <span className="nx-access__value">{user.email}</span>
        </div>
        <div className="nx-access__row">
          <span className="nx-access__label">Organisation</span>
          <span className="nx-access__value">{user.organisation}</span>
        </div>
        <div className="nx-access__row">
          <span className="nx-access__label">Client</span>
          <span className="nx-access__value">{cfg.client.label}</span>
        </div>
        <div className="nx-access__row">
          <span className="nx-access__label">Roles</span>
          <span className="nx-access__value">
            {user.roles.length === 0
              ? <StatusChip status="offline" label="No role assigned" />
              : user.roles.map((r) => <StatusChip key={r} status="active" label={r} />)}
          </span>
        </div>
      </section>
    </div>
  );
}